import {
  ArrayLocationAPIResponse,
  SiteRFPPhaseAPIResponse,
  SiteRFPSummary,
  SiteRFPSummariesResponseBody,
} from '@black-bear-energy/black-bear-energy-common'
import { parseNullableEnum } from './parseNullableEnum'
import { parseEnum } from './parseEnum'

type SiteRFPAPIResponseRecord = SiteRFPSummariesResponseBody['records'][number]

export const transformSiteRFPSummary = (
  record: SiteRFPAPIResponseRecord
): SiteRFPSummary => ({
  siteRFPId: record.siteRFPId,
  siteRFPName: record.siteRFPName,
  section: record.section,
  customerRFPName: record.customerRFPName,
  systemSize: record.systemSize,
  arrayLocation: parseNullableEnum(
    record.arrayLocation,
    ArrayLocationAPIResponse,
    'arrayLocation'
  ),
  phase: parseEnum(record.phase, SiteRFPPhaseAPIResponse, 'phase'),
  constructionStartDate: record.constructionStartDate
    ? parseDate(record.constructionStartDate)
    : null,
  commercialOperationDate: record.commercialOperationDate
    ? parseDate(record.commercialOperationDate)
    : null,
  commercialOperationDateEstimate: record.commercialOperationDateEstimate
    ? parseDate(record.commercialOperationDateEstimate)
    : null,
})

const parseDate = (value: string): Date => {
  const d = new Date(value)
  if (isNaN(d.getTime())) {
    throw new Error(`Invalid date string from API: "${value}"`)
  }
  return d
}
